<template>
  <v-app style="height: 150px;">
    <div class="header-container">
      <!-- Barra de navegación en pantallas grandes -->
      <v-app-bar class="nav-bar">
        <v-btn text class="nav-link" @click="$router.push('/home')">Inicio</v-btn>
        <v-btn text class="nav-link">Servicios</v-btn>
        <v-btn text class="nav-link">Transparencia</v-btn>
        <v-btn text class="nav-link">Estadística</v-btn>
        <v-btn text class="nav-link">Agencias</v-btn>
        <v-btn text class="nav-link">Micrositios</v-btn>
        <v-btn text class="nav-login" @click="handleClick()">Iniciar sesión</v-btn>
      </v-app-bar>

      <!-- Barra de navegación en pantallas móviles -->
      <v-app-bar class="mobile-bar" app>
        <v-btn icon @click="drawer = !drawer">
          <v-icon style="color: #c09c54">mdi-menu</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Menú lateral en móviles -->
      <v-navigation-drawer v-model="drawer" app temporary class="navegacion">
        <v-list>
          <v-list-item class="spacer" v-if="isMobile"></v-list-item>

          <v-list-item @click="$router.push('/home')">
            <v-list-item-title class="drawer-text">Inicio</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="drawer-text">Servicios</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="drawer-text">Transparencia</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="drawer-text">Estadística</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="drawer-text">Agencias</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="drawer-text">Micrositios</v-list-item-title>
          </v-list-item>

          <v-list-item @click="handleClick()">
            <v-list-item-title class="drawer-text">Iniciar sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <!-- Contenedor del logo -->
      <div class="logo-container">
        <img :src="getThemeImage('logo_header')" alt="Logo" class="logo"/>
        <img :src="getThemeImage('logo_flor')" class="flor_logo" alt=""/>

      </div>

    </div>
  </v-app>
</template>


<style scoped>
/* Estilo del contenedor del logo */
.logo-container {
  background: v-bind($vuetify.theme.themes.light.bg_header);
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

/* Estilo del logo */
.logo {
  width: auto;
  height: auto;
  padding: 100px 0 50px 70px;
}

/* Estilo de la barra de navegación */
.nav-bar {
  background: v-bind($vuetify.theme.themes.light.bg_header) !important;
  position: absolute;
  z-index: 1000;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 0 0 0 70px;

}

/* Estilo de los enlaces de navegación */
.nav-link {
  color: white;
  align-items: center;
}

.nav-login {
  background: #265B4E !important;
  color: #fff !important;
  font-weight: 800;
  border-radius: 999px;
  height: 32px;
  padding: 0 14px;
  margin-left: 8px;
}

/* Barra de navegación móvil oculta por defecto */
.mobile-bar {
  display: none;
  background: v-bind($vuetify.theme.themes.light.bg_header) !important;;
}

/* Espaciador para la lista */
.spacer {
  height: 50px;
}

/* Estilo del drawer (menú lateral) */
.navegacion {
  background: v-bind($vuetify.theme.themes.light.bg_header);
  align-content: center;
}

/* Forzar texto blanco en el drawer */
.drawer-text {
  color: white !important;
}

.flor_logo{
  position: relative;
  top: 55px;
  right: 0;
  width: 200px;
  height: 160px;
  left: 5px;
}
/* Adaptaciones para pantallas menores a 885px */
@media (max-width: 885px) {
  .nav-bar {
    display: none;
  }

  .mobile-bar {
    display: flex;
  }

  .logo {
    width: 90%;
    max-width: 100%;
  }
}
</style>

<script>
import {loginRedirect} from "@/store/keycloak";

export default {
  data() {
    return {
      drawer: false,
      isMobile: window.innerWidth <= 885,
    };
  },

  computed: {
    getThemeImage() {
      return (key) => {
        const themeIcons = this.$vuetify.theme.themes.light?.icons;
        if (!themeIcons || !themeIcons[key]) {
          console.warn(` La clave "${key}" no existe en los iconos del tema.`);
          return "";
        }

        const path = themeIcons[key];

        try {
          return require(`@/assets/${path}`);
        } catch (error) {
          console.error(`Error al cargar la imagen: ${path}`, error);
          return "";
        }
      };
    },
  },

  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },

  methods: {


    checkScreenSize() {
      this.isMobile = window.innerWidth <= 885;
    },
    handleClick() {
      loginRedirect()
    }
  },
};

</script>
